import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import { GetFormatedDateWithTime } from '../../../../common/Utils'
import RenderSelectBoxCell from "../../../../common/RenderCell";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    StateStoring,
    RequiredRule,
    ValidationRule
} from "devextreme-react/data-grid";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import { Button } from 'devextreme-react';
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
import data from "../../../../assets/apiRoutes.json";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";
import { MESSAGES } from "../../../../common/Messages";
import CrateDetailFromLocation, { CrateLocationMode } from "../common/CrateDetailFromLocation";
let status = "";
const ContentsDetailTab = (props) => {
    const dataGrid = useRef(null);
    const [showCrateAllocation, setShowCrateAllocation] = useState(false);
    const [pendingInsertData, setPendingInsertData] = useState(null);
    const [isInserting, setIsInserting] = useState(false);

    // Which way the WMD0049 transfer runs, and therefore which caption and explanation it shows.
    const [locationMode, setLocationMode] = useState(CrateLocationMode.Add);

    // The location the operator chose in WMD0049. Held in a ref because the CustomStore's onBeforeSend
    // runs from the closure the grid captured on its first render, which would never see a state update.
    const transferRef = useRef({ RLocation: null, RWarehouse: null });

    const gridKey = "D45E1148-EF9C-4491-9DE1-8081D7782C1F";
    const isFormLoadRef = useRef(true);
    var url = "im/CrateDetail/GetCrateDetails";
    var updateUrl = "im/CrateDetail/UpdateCrateDetails";
    var insertUrl = "im/CrateDetail/InsertCrateDetails";
    const dataSource = createStore({
        key: 'RowId',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        loadParams: {
            RowId: props.sourceId,
            Module: props.Module,
        },
        insertUrl: `${window._env_.REACT_APP_APIS}/${insertUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
            if (method === "update" || method === "insert") {
                let valuesObj = JSON.parse(ajaxOptions.data.values);
                valuesObj.Module = props.Module;
                valuesObj.RCrate = props.sourceId;
                // The end of the transfer the operator chose. The other end is the crate header's own
                // location, which the service reads for itself.
                valuesObj.RLocation = transferRef.current.RLocation;
                ajaxOptions.data.values = JSON.stringify(valuesObj);
            }
        }
        ,
        onUpdated: function (e) {
            isFormLoadRef.current = false;
        },
        onInserted: function (e) {
            isFormLoadRef.current = false;
        }

    });
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [selectedItemData, setSelectedItemData] = useState(null);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    }
    const deleteRecords = useCallback(() => {
        var deleteUrl = "im/CrateDetail/DeleteCrateDetails";
        const formData = new FormData();
        const item = selectedItemData;
        item.RLocation = transferRef.current.RLocation;
        Object.keys(item).forEach(key => {
            formData.append(key, item[key]);
        });

        axios.put
            (
                `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                formData,
                {
                    // No explicit Content-Type: the body is FormData and the endpoint binds it with
                    // [FromForm], so axios has to set multipart/form-data with its own boundary. Declaring
                    // application/json over a multipart body left the DTO unbound - the delete reached the
                    // server, matched no row, and reported success while deleting nothing.
                    headers: {
                        access_token: accessToken,
                    },
                }
            )
            .then((res) => {
                // The row is gone either way; ERRORS reports only that the inventory stayed put. Shown as
                // the same plain sentence the add path uses - the raw text behind it is the database's own
                // ("No Records Transfered by SPIM_LocationTransfer"), which names our internals and tells
                // an operator nothing. It is logged on the server for whoever has to chase it.
                if (res.data.ERRORS && res.data.ERRORS.length > 0) {
                    alert(MESSAGES.NO_Location_Transfer, MESSAGES.WARNING);
                }
                dataGrid.current.instance().refresh();
            })
            .catch((err) => {
                alert(err);
            });


    }, [selectedItemKeys, selectedItemData]);
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
        setSelectedItemData(data.selectedRowsData[0]);
    }

    const rowInserting = (e) => {
        // Delphi shows WMD0049 from BeforePost, so the line is held back until the transfer's other end
        // is known and only written if the operator goes through with it.
        setLocationMode(CrateLocationMode.Add);
        setShowCrateAllocation(true);
        setIsInserting(true);
        setPendingInsertData(e.data); // Store the data to insert
        e.cancel = true; // Always cancel, will insert manually if confirmed
    };

    // The crate line WMD0049 is being opened for - the one being added, or the one being removed. Its
    // item type and keys are what the location lookup is narrowed on.
    const locationDetail = locationMode === CrateLocationMode.Remove ? selectedItemData : pendingInsertData;

    // The blank-location and blank-warehouse questions belong to WMD0049 and are asked there; by the
    // time this runs the operator has already answered them.
    const handleCrateAllocationOk = (transfer) => {
        transferRef.current = transfer;
        setShowCrateAllocation(false);
        if (pendingInsertData) {
            dataSource.insert(pendingInsertData).then((result) => {
                // The line is recorded whether or not the transfer ran, so the grid is brought up to date
                // either way. ERRORS here reports only that the inventory did not move - treating it as a
                // failed insert left the new row off the grid and the editor still open, so the operator
                // believed nothing had been saved when it had.
                if (result && result.ERRORS && result.ERRORS.length > 0) {
                    alert(MESSAGES.NO_Location_Transfer, MESSAGES.WARNING);
                }
                dataGrid.current.instance().refresh();
                dataGrid.current.instance().cancelEditData();
            });
            setPendingInsertData(null);
            setIsInserting(false);
        }
        else if (selectedItemKeys) {
            deleteRecords();
        }
    };

    // Cancelling the dialog aborts the add or the delete outright (GetFromLocation returns False and
    // BeforePost / BeforeDelete call abort).
    const handleCrateAllocationCancel = () => {
        setShowCrateAllocation(false);
        setPendingInsertData(null); // Do not insert
        setIsInserting(false);
    };
    return (
        <div >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                onContentReady={onContentReady}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                onRowInserting={rowInserting}
                height='71vh'
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />

                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    allowUpdating={isInserting}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column dataField="CustomerId" caption="Customer" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadParams: {
                                lookupType: function () {
                                    return "Customer";
                                },
                                module: function () {
                                    return "id";
                                }
                            },
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Common.GetLookup}`,
                            key: "id",
                            displayExpr: "identityid",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RCustomer,
                            sort: [{ selector: "identityid", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.CustomerId = newValue.text;
                        rowData.RCustomer = newValue.value;
                    }}
                >
                    <RequiredRule message="Customer is required" />
                </Column>
                <Column dataField="ItemCode" caption='Item'
                    allowEditing={true}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Item.GetItems}`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RItem,
                            loadParams: {
                                customerIdentity: function () {
                                    return cellElement.data.RCustomer;
                                }
                            },
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: (value, text, additionalData) => {
                                cellElement.setValue(({ value, text, additionalData }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.ItemCode = newValue.text;
                        rowData.RItem = newValue.value;
                        rowData.ItemType = newValue.additionalData?.itemtype || null;
                    }}
                >  <RequiredRule message="Item is required" /></Column>
                <Column dataField="LotCode" caption='Lot'
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Lot.GetLots}`,
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RLot,
                            loadParams: {
                                masterRowId: function () {
                                    return cellElement.data.RItem;
                                }
                            },
                            // The lookup returns LookupDTO (id / name), not the grid's own column names -
                            // DataSourceLoader sorts against that type, so "LotCode" threw "'LotCode' is not
                            // a member of type ... LookupDTO" and the lookup came back empty rows.
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.LotCode = newValue.text;
                        rowData.RLot = newValue.value;
                    }}
                ></Column>
                <Column dataField="SubLotCode" caption='Sub Lot'
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Common.GetLookup}`,
                            key: "RowId",
                            displayExpr: "SublotCode",
                            valueExpr: "RowId",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RSublot,
                            loadParams: {
                                lookupType: function () {
                                    return "IMSublot";
                                },
                                module: function () {
                                    return "IM";
                                },
                                lotId: function () {
                                    return cellElement.data.RLot;
                                },
                                isPascalCase: function () {
                                    return true;
                                }
                            },
                            sort: [{ selector: "SublotCode", desc: false }],
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.SubLotCode = newValue.text;
                        // The sub-lot's own key. Writing it to RLot overwrote the lot chosen a column
                        // earlier, which left the line keyed on a sub-lot id the lot lookup could not
                        // match and sent the location transfer down to the wrong level.
                        rowData.RSublot = newValue.value;
                    }}
                ></Column>
                <Column dataField="QuantityOrdered" caption='Ordered' allowEditing={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="QuantityActual" caption='Actual' dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} >
                    <RequiredRule message="Actual quantity is required" />
                    <ValidationRule
                        type="range"
                        min={1}
                        message={MESSAGES.ACTUAL_QUANTITY_MIN}
                    />
                </Column>
                <Column dataField="Reference" caption='Reference' dataType="string" />
                <Column dataField="ReferenceDateTime" caption='Reference Date' dataType="date" />
                <Column dataField="WorkerId" caption='Worker' editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/${data.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Identityid",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RSublot,
                        loadParams: {
                            lookupType: function () {
                                return "Worker";
                            },
                            module: function () {
                                return "Id";
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        sort: [{ selector: "Identityid", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.WorkerId = newValue.text;
                        rowData.RWorker = newValue.value;
                    }}
                ></Column>
                <Column allowEditing={false} dataField="CustomerName" caption='Name' dataType="string" />
                <Column allowEditing={false} dataField="TransactionNumber" caption='Transaction #' dataType="string" />
                <Column allowEditing={false} dataField="TransactionDate" caption='Transaction' dataType="datetime" />
                <Column allowEditing={false} dataField="ShipperBolNumber" caption='Shipper #' dataType="string" />
                <Toolbar>
                    <Item
                        name="addRowButton"
                        onClick={() => setIsInserting(true)}
                    />
                    <Item location="after">
                        <Button
                            onClick={() => {
                                let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
                                result.then((dialogResult) => {
                                    if (dialogResult) {
                                        // Removing an item is a transfer the other way round, so the
                                        // dialog asks for a To Location (BeforeDelete sets DetailType 'M').
                                        setLocationMode(CrateLocationMode.Remove);
                                        setShowCrateAllocation(true)
                                    }
                                });
                            }}
                            icon="trash"
                            disabled={!selectedItemKeys.length}
                        />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <CrateDetailFromLocation
                visible={showCrateAllocation}
                mode={locationMode}
                detail={locationDetail}
                module={props.Module}
                onOk={handleCrateAllocationOk}
                onCancel={handleCrateAllocationCancel}
            />
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(ContentsDetailTab);